import {useQuery, useMutation} from 'admin/lib/apollo'
import {useQueryParams, StringParam, NumberParam, withDefault} from 'use-query-params'
import {GET_PAYMENTS, UPDATE_PAYMENTS} from '../gql/Payments.gql'
import clearCache from './clearCache'

export default (state, {skip = false} = {}) => {
  const [filters, setFilters] = useQueryParams({
    q: StringParam,
    fromDate: StringParam,
    toDate: StringParam,
    page: withDefault(NumberParam, 1),
    limit: NumberParam,
    sortBy: withDefault(StringParam, 'payments.date'),
    sortDirection: withDefault(StringParam, 'desc')
  })

  const variables = {state, ...filters}

  const {data: {payments = {}} = {}, error: getError} = useQuery(GET_PAYMENTS, {variables, skip})
  const [update] = useMutation(UPDATE_PAYMENTS, {
    flash: 'Payments updated',
    update: (cache, {errors}) => {
      if (!errors) {
        const toClear = state === 'pending' ? {paymentsPending: null} : {payments: null}
        return clearCache(toClear)(cache)
      }
    }
  })

  return {
    payments: payments.collection || [],
    update,
    filters,
    setFilters,
    totalCount: payments.metadata?.totalCount || 0,
    errors: getError || {}
  }
}
